import * as React from 'react'
import { withLogger, ILogger } from '../../context/withLogger'
import { IDetailPageState } from '../../reducers'
import {
  sanitizedRequestContextSelector,
  IRequestContext,
} from '../../selectors/requestContext'
import { connect } from 'react-redux'
import { COUNTER_PACKAGE_PREFIX } from '../../utils/utils'

interface IState {
  error?: Error
  info?: React.ErrorInfo
}

type OwnProps = {
  name: string
}

type StateProps = {
  requestContext: IRequestContext
}

// Note the error boundary feature only works on client side
class ErrorBoundaryWithContext<
  T extends ILogger & OwnProps & StateProps
> extends React.Component<T, IState> {
  constructor(props: T) {
    super(props)
    this.state = { error: undefined, info: undefined }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    const { logger, name } = this.props
    const label = `${COUNTER_PACKAGE_PREFIX}_ErrorBoundary_${name}`
    logger.fatal(label, error).count(label, 1, false)
    this.setState({ error, info })
  }

  render() {
    const { error } = this.state
    const {
      requestContext: { isInternal },
    } = this.props
    if (error) {
      return isInternal ? (
        <div>
          <div>${error.message}</div>
          <div>${error.stack}</div>
        </div>
      ) : null
    }

    return this.props.children
  }
}

const mapStateToProps = (state: IDetailPageState): StateProps => ({
  requestContext: sanitizedRequestContextSelector(state),
})

export const ErrorBoundary = connect(mapStateToProps)(
  withLogger(ErrorBoundaryWithContext)
)
